import { zodResolver } from "@hookform/resolvers/zod";
import { FieldValues, Resolver } from "react-hook-form";

/**
 * Typed wrapper around zodResolver for forms where the Zod schema
 * validates a subset of the form's fields. Uses `raw: true` so
 * unmatched fields pass through untouched to onSubmit.
 *
 * The internal cast bridges Zod v4's inferred schema types with
 * react-hook-form's form type — this is safe because `raw: true`
 * returns the original form values, not the Zod-parsed output.
 */
export function zodFormResolver<T extends FieldValues>(schema: Parameters<typeof zodResolver>[0]): Resolver<T> {
  return zodResolver(schema, undefined, { raw: true }) as Resolver<T>;
}
